export default {
  "fontElementMap": "Ao3eA",
  "hideText": "rlWkn",
  "onHoverText": "xSEz1",
  "hideBlock": "q4F1i",
  "smallBlur": "x4B7X",
  "mediumBlur": "P5rLn",
  "largeBlur": "_7UwSP",
  "hideBlock_gallery": "_9qeoh",
  "overlay": "Pby7G",
  "overlay_gallery": "CMKUz",
  "revealSpoilerBtn": "t7hpV",
  "isMobile": "_4Kt-X",
  "onHoverBtn": "iJOSF",
  "spoilerWrapper": "AHyiv",
  "spoilerDescription": "d6uDq",
  "spoilerContainer": "eEebn",
  "spoilerContainer_Gallery": "GJfTd"
};